module.exports = __webpack_public_path__ + "media/assets/images/flags/kw-d47f0e56dbcc6f0b80eafccbf397e65c.svg";